import React from 'react'
import Experiment from '@mc/experiments-react'
import { BOGO_OFFER_VARIABLES_FLAG_NAME } from '../../constants'
import { ExperimentVariable } from '../../types'
import { StyledVariableProps } from '../StyledVariable'
import { InnerStyledFeatureVariable } from './InnerStyledFeatureVariable'

type StyledFeatureVariableProps = Omit<StyledVariableProps, 'text'> & {
  flagName?: string
  variableName: string
  textKey?: string
  variables?: ExperimentVariable
  trackEV?: boolean
}

export const StyledFeatureVariable = ({
  flagName = BOGO_OFFER_VARIABLES_FLAG_NAME,
  trackEV = false,
  ...props
}: StyledFeatureVariableProps) => (
  <Experiment
    name={flagName}
    default={InnerStyledFeatureVariable}
    lazyload={false}
    track={trackEV}
    {...props}
  />
)
